
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai_policy",
      function () {
        return require("private-next-pages/ai_policy.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai_policy"])
      });
    }
  